import { forwardRef, useRef } from "react";
import styles from "./GoogleAddressInput.module.scss";
import Autocomplete from "react-google-autocomplete";
import Input from "./Input";
import States from "../constant/states";
import Select from "./Select";

const GoogleAddressInput = forwardRef(function GoogleAddressInput(props, ref) {
  const { label, mandatory, errors, clearError, setError } = props;

  const myGoogleApiKey = "AIzaSyC5K5DOT15-NBDl2JuCNZGzXafuH4rMviA";

  const addressLineRef = useRef();
  const suburbRef = useRef();
  const stateRef = useRef();
  const postcodeRef = useRef();

  // function clearErrorHandler(){
  //   clearError();
  // }

  // function setErrorHandler(){
  //   setError();
  // }
  function handlePlaceSelected(place) {
    if (place === undefined) return;

    //find the unitno if exists
    var unitParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "subpremise") > -1
    );
    var streetNoParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "street_number") > -1
    );
    var streetNameParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "route") > -1
    );
    var suburbParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "locality") > -1
    );
    var stateParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "administrative_area_level_1") > -1
    );
    var postcodeParts = place.address_components.filter(
      (x) => x.types.findIndex((t) => t === "postal_code") > -1
    );

    let addressLine = `${streetNoParts[0].short_name} ${streetNameParts[0].short_name}`;

    if (unitParts.length > 0) {
      addressLine = unitParts[0].short_name + " " + addressLine;
    }

    addressLineRef.current.value = addressLine;

    suburbRef.current.value =
      suburbParts.length > 0 ? suburbParts[0].short_name : "";
    stateRef.current.value =
      stateParts.length > 0 ? stateParts[0].short_name : "";
    postcodeRef.current.value =
      postcodeParts.length > 0 ? postcodeParts[0].short_name : "";

    if (addressLineRef.current.value) clearError("AddressLine1");
    if (suburbRef.current.value) clearError("Suburb");
    if (stateRef.current.value) clearError("State");
    if (postcodeRef.current.value) clearError("Postcode");
  }
  return (
    <>
      <div className={styles.formGroup}>
        <label>
          {label}
          {mandatory && <label className={styles.mandatory}>*</label>}
          <Autocomplete
            name="AddressLine1"
            id="AddressLine1"
            ref={addressLineRef}
            apiKey={myGoogleApiKey}
            onPlaceSelected={(place) => {
              handlePlaceSelected(place);
            }}
            options={{
              types: ["address"],
              componentRestrictions: { country: "au" },
            }}
          />
        </label>
        <div className="error">
          {errors["AddressLine1"] ? "Street address is required" : ""}
        </div>
      </div>

      <Input
        name="Suburb"
        id="Suburb"
        type="text"
        label="Suburb"
        mandatory={true}
        ref={suburbRef}
        clearError={clearError}
        setError={setError}
        error={errors["Suburb"] ? "Suburb is required" : ""}
      />
      <div className={styles.stateWrapper}>
        <Select
          name="State"
          id="State"
          label="State"
          ref={stateRef}
          mandatory={true}
          simpleValues={States}
          clearError={clearError}
          setError={setError}
          error={errors["State"] ? "State is required" : ""}
        ></Select>
        <Input
          name="Postcode"
          id="Postcode"
          type="text"
          label="Postcode"
          ref={postcodeRef}
          mandatory={true}
          clearError={clearError}
          setError={setError}
          error={errors["Postcode"] ? "Postcode is required" : ""}
        />
      </div>
    </>
  );
});

export default GoogleAddressInput;
